export const byFeatureCacheKey = (_state, feature) => `${feature || 'unknown'}`
